import { pxToRem } from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import { Colors, colors } from '@modernhealth/vital-foundation';
import React from 'react';
import { hexToRgba } from 'src/shared/helpers/hexToRgba';

interface MilestoneBadgeProps {
    children: React.ReactNode;
    isCompleted: boolean;
    completedColor?: Colors;
    size?: number;
    borderWidth?: number;
    borderColor?: Colors;
    title?: React.ReactNode;
}

const BadgeWrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

export const MilestoneBadge: React.FC<MilestoneBadgeProps> = ({
    children,
    isCompleted,
    completedColor = 'cyan55',
    size,
    borderWidth,
    borderColor = 'cyan05',
    title,
}) => {
    return (
        <BadgeWrapper aria-hidden>
            <MilestoneBadgeContent
                size={size}
                isCompleted={isCompleted}
                borderWidth={borderWidth}
                completedColor={completedColor}
                borderColor={borderColor}
            >
                {children}
            </MilestoneBadgeContent>
            {title}
        </BadgeWrapper>
    );
};

const MilestoneBadgeContent = styled('div')(
    ({
        size,
        borderWidth,
        isCompleted,
        completedColor,
        borderColor,
    }: Pick<MilestoneBadgeProps, 'size' | 'borderWidth' | 'isCompleted'> & {
        completedColor: Colors;
        borderColor: Colors;
    }) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        backgroundColor: isCompleted ? colors[completedColor] : colors.gray30,
        width: size ? pxToRem(size) : pxToRem(58),
        height: size ? pxToRem(size) : pxToRem(58),
        color: colors.white,
        borderWidth: borderWidth ? borderWidth : '6px',
        borderColor: isCompleted ? colors[borderColor] : colors.gray05,
        borderStyle: 'solid',
    }),
);

export const MilestoneWrapper = styled('div')({ display: 'flex', justifyContent: 'center' });

export const MilestoneBadgeDecorator = styled('span')(
    ({ borderColor }: { borderColor?: Colors }) => ({
        position: 'relative',
        border: `${pxToRem(48)} solid ${hexToRgba(
            borderColor ? colors[borderColor] : colors.cyan05,
            0.5,
        )}`,
        borderRadius: '50%',
        width: pxToRem(206),
        height: pxToRem(206),
    }),
);
